import { render, staticRenderFns } from "./ProdutosCadastroForm.vue?vue&type=template&id=44fabd36&scoped=true&"
import script from "./ProdutosCadastroForm.vue?vue&type=script&lang=js&"
export * from "./ProdutosCadastroForm.vue?vue&type=script&lang=js&"
import style0 from "./ProdutosCadastroForm.vue?vue&type=style&index=0&id=44fabd36&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44fabd36",
  null
  
)

export default component.exports